/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const AssessedItemType = {
    ELIGIBLE: 'ELIGIBLE',
    LIMITED: 'LIMITED'
} as const;
export type AssessedItemType = typeof AssessedItemType[keyof typeof AssessedItemType];

